import React from "react";
import Banner from "./Banner/Banner";
import User1 from "../../assets/images/authorImg1.png";
import {
  GoverningCouncilData,
  NationalAdvisorsData,
  ZonalCoordinatorData,
  executiveComittiesData,
  nominationFormData,
} from "./GovernanceData";

import styles from "./Governance.module.css";

const Governance = () => {
  return (
    <main className={styles.governancePage}>
      <Banner />
      {/* Governing Academic Council */}
      <section className={styles.governingCouncel}>
        <div className={styles.container}>
          <h3>
            Governing <span>Academic Council</span>
          </h3>
          <h5>
            Distinguished academic leaders providing strategic direction and
            oversight for IMPARC initiatives
          </h5>
          <div className={styles.cards}>
            {GoverningCouncilData.map((m, idx) => (
              <div key={idx} className={styles.card}>
                <figure>
                  <img src={m.img} alt={m.name} />
                </figure>
                <h4>{m.name}</h4>
                <p>{m.role}</p>
                {m.education && (
                  <p className={`${styles.icons} ${styles.education}`}>
                    {m.education}
                  </p>
                )}
                {m.awards && (
                  <p className={`${styles.icons} ${styles.awards}`}>
                    {m.awards}
                  </p>
                )}
                {m.publication && (
                  <p className={`${styles.icons} ${styles.publication}`}>
                    {m.publication}
                  </p>
                )}
                {m.represented && (
                  <p className={`${styles.icons} ${styles.represented}`}>
                    {m.represented}
                  </p>
                )}
                {m.scope && (
                  <p className={`${styles.icons} ${styles.scope}`}>{m.scope}</p>
                )}
                {m.policy && (
                  <p className={`${styles.icons} ${styles.policy}`}>
                    {m.policy}
                  </p>
                )}

                <button className={styles.cardBtn}>View Profile</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* National Advisors */}
      <section className={styles.sectionAlt}>
        <div className={styles.container}>
          <h3>
            National <span>Advisors</span>
          </h3>
          <h5>
            Renowned experts providing strategic guidance and domain expertise
            across various research fields
          </h5>
          <div className={styles.cardGrid}>
            {NationalAdvisorsData.map((a, idx) => (
              <div key={idx} className={styles.card}>
                <div className={styles.innerWhite}>
                  <figure>
                    <img src={a.img || User1} alt={a.name} />
                  </figure>
                  <h4>{a.name}</h4>
                  <p>{a.field}</p>
                  <p className={styles.university}>{a.university}</p>
                  <div className={styles.tagOuter}>
                    <span className={styles.tag}>{a.tag}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Zonal & State Coordinators */}
      <section
        className={`${styles.governingCouncel} ${styles.zonalCoordinator}`}
      >
        <div className={styles.container}>
          <h3>
            Zonal & State <span>Coordinators</span>
          </h3>
          <h5>
            Regional leadership ensuring effective implementation and local
            engagement across India
          </h5>
          <div className={styles.cards}>
            {ZonalCoordinatorData.map((zoneData, idx) => (
              <div key={idx} className={styles.card}>
                <div className={styles.heading}>
                  <h4>{zoneData.zone}</h4>
                  <span className={styles.stateCount}>
                    {zoneData.stateCount}
                  </span>
                </div>
                <ul>
                  {zoneData.doctorList.map((item) => (
                    <li key={item.name}>
                      <div className={styles.left}>
                        <h6>{item.name}</h6>
                        {item.designation}
                      </div>
                      <div className={styles.right}>{item.state}</div>
                    </li>
                  ))}
                </ul>
                <button className={styles.cardBtn}>
                  View All Coordinators
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Executive Committees */}
      <section
        className={`${styles.governingCouncel} ${styles.executiveComitties}`}
      >
        <div className={styles.container}>
          <h3>
            Executive <span>Committees</span>
          </h3>
          <h5>
            Specialized committees driving strategic initiatives and operational
            excellence
          </h5>

          <div className={styles.cards}>
            {executiveComittiesData.map((m, idx) => (
              <div key={idx} className={styles.card}>
                <div className={styles.title}>{m.title}</div>
                <ul>
                  {m.items.map((item) => (
                    <li key={item.name}>
                      {item.name}
                      <span className={styles.count}>{item.count}</span>
                    </li>
                  ))}
                </ul>
                <button className={styles.cardBtn}>
                  View Committee Details
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Nomination & Application */}
      <section
        className={`${styles.governingCouncel} ${styles.nominationApplication}`}
      >
        <div className={styles.container}>
          <h3>
            Nomination & <span>Application Forms</span>
          </h3>
          <h5>
            Join our leadership team and contribute to advancing research
            excellence
          </h5>

          <div className={styles.cards}>
            {nominationFormData.map((m, idx) => (
              <div key={idx} className={styles.card}>
                <figure>
                  <img src={m.img} alt={m.name} />
                </figure>
                <h4>{m.title}</h4>
                <p>{m.desc}</p>

                {m.featureList.map((item) => (
                  <div className={styles.blueArrow} key={item.id}>
                    {item}
                  </div>
                ))}

                <button className={styles.cardBtn}>{m.buttonText}</button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Governance;
